// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"9e0b35e6","200":"4460b55a","279":"5ad4ba1b","453":"27b5e3e7","765":"86ca8056"}[chunkId] + ".chunk.js";
};